module.exports = __webpack_public_path__ + "static/preview-albert-f7fa25c12767cc79ef531159f3a570b5.wav";